export default __webpack_public_path__ + "static/media/massup_logo.24760797.svg";